import { RegistrationForm } from "./RegistrationForm";

export { RegistrationForm };
